module.exports = __webpack_public_path__ + "img/logo43.947d4bf1.png";